import React, { useEffect, useRef } from "react";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import AgitateSection from "../components/landing/AgitateSection";
import PersonajeSection from "../components/landing/PersonajeSection";
import NoEnemigoSection from "../components/landing/NoEnemigoSection";
import ConsequencesSection from "../components/landing/ConsequencesSection";
import TransformationSection from "../components/landing/TransformationSection";
import SantiSection from "../components/landing/SantiSection";
import MasterclassSection from "../components/landing/MasterclassSection";
import Footer from "../components/landing/Footer";
import WhatsAppFab from "../components/landing/WhatsAppFab";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";
import { firePageView } from "../lib/capiClient";
import { captureAttribution } from "../lib/attribution";
import { hasAdConsent, onConsentChange } from "../lib/consent";

export default function Landing() {
  const firedRef = useRef(false);

  useEffect(() => {
    // Capture UTM + referrer once — must happen before any internal link
    // click can strip the URL params. Safe to call on every mount; it only
    // refreshes when a NEW utm_source arrives.
    captureAttribution();

    // AEPD: only fire Meta events after the user grants advertising consent.
    const tryFire = () => {
      if (firedRef.current) return;
      if (!hasAdConsent()) return;
      firedRef.current = true;
      firePageView();
    };
    tryFire();
    const off = onConsentChange(tryFire);
    return () => off();
  }, []);

  return (
    <div className="min-h-screen bg-bg-base text-ink relative overflow-hidden" data-testid="landing-page">
      <Nav />
      <Hero />
      <AgitateSection />
      <PersonajeSection />
      <NoEnemigoSection />
      <ConsequencesSection />
      <TransformationSection />
      <SantiSection />
      <MasterclassSection />
      <Footer />
      <WhatsAppFab />
      <MobileStickyCTA />
    </div>
  );
}
